<template>
	<div class="wrapper form">
		<div class="input-wrapper">
			<div class="input__title">Finanszírozó adatai:</div>
			<div class="input__field">
				<CalcElem
					:options="optionsForName"
					type="contracting"
					class="w-50 mobile-width-full"
					name="ws_id"
					@click="handleClick"
					:index="1"
				/>
				<CalcElem
					v-for="(field, fIndex) in fields.creditorDetails"
					:key="fIndex"
					:options="field"
					type="contracting"
					:class="field.inputClass"
					:name="fIndex"
					:ref="`${fIndex}-1`"
					:index="1"
				/>
			</div>
		</div>
		<div class="input-wrapper">
			<div class="input__title">Finanszírozási szerződés adatai:</div>
			<div class="input__field">
				<CalcElem
					v-for="(field, fIndex) in fields.lendingDetails"
					:key="fIndex"
					:options="field"
					type="contracting"
					:class="field.inputClass"
					:index="1"
				/>
			</div>
		</div>
	</div>
</template>

<script>
import _ from 'lodash';
import dataPages from '@/mixins/dataPages';
import financing from '@/mixins/financing';

export default {
	mixins: [financing, dataPages],
	data() {
		return {
			insurer: 'granit',
			type: 'financingData',
		};
	},
};
</script>
